var EVENTS = {
    sendMessage: { evid: 1101 },
    switchKeyboard: { evid: 1102 },
    openChatroom: { evid: 1103 }
};
export { EVENTS };
